import { Component, Input } from '@angular/core';
import { MatDialogActions } from '@angular/material/dialog';

// Footer for form dialogs: an optional "* Required field" note on the left and the
// projected action buttons on the right. Use with the 'form-dialog' panel class.
@Component({
    selector: 'app-dialog-footer',
    imports: [MatDialogActions],
    templateUrl: './dialog-footer.component.html',
    styleUrl: './dialog-footer.component.scss'
})
export class DialogFooterComponent {
  @Input() showRequiredNote = true;
}
